/**
 * Initializes the state for the reducer getting hotloaded
 * @type {string}
 */
export const INIT_STATE = 'INIT_STATE';
